import script from "./IdleView.vue?vue&type=script&setup=true&lang=ts"
export * from "./IdleView.vue?vue&type=script&setup=true&lang=ts"

import "./IdleView.vue?vue&type=style&index=0&id=3d926082&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d926082"]])

export default __exports__